/** @file clickSelection: the node list a row click produces (plain, Ctrl toggle, Shift range in tree order). */

/** The click's modifiers: Ctrl or Cmd toggles, Shift selects a range. */
export type ClickMods = { toggle: boolean; range: boolean };

/**
 * Plain: just `name`. Toggle: `name` added at the end, or removed (the first node stays the primary). Range: from
 * `anchor` to `name` in `order` (the visible rows), the anchor first so it stays primary; without a visible anchor it
 * is a plain click. Returns the new nodes and the new anchor (a range keeps its anchor).
 */
export function clickSelection(order: readonly string[], selected: readonly string[], anchor: string | null, name: string, mods: ClickMods): { nodes: string[]; anchor: string | null } {
  if (mods.range) {
    const [a, b] = [anchor === null ? -1 : order.indexOf(anchor), order.indexOf(name)];
    if (a >= 0 && b >= 0) {
      const span = order.slice(Math.min(a, b), Math.max(a, b) + 1).filter((n) => n !== anchor);
      return { nodes: [order[a] ?? name, ...(a <= b ? span : span.reverse())], anchor };
    }
  }
  if (mods.toggle) {
    const nodes = selected.includes(name) ? selected.filter((n) => n !== name) : [...selected, name];
    return { nodes, anchor: name };
  }
  return { nodes: [name], anchor: name };
}
